/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiAuthorsMutationRequest, PostApiAuthorsMutationResponse, PostApiAuthors400, PostApiAuthors401, PostApiAuthors403, PostApiAuthors500 } from "../../types/PostApiAuthors.ts";
import { postApiAuthorsMutationResponseSchema, postApiAuthorsMutationRequestSchema } from "../../zod/AuthorSchemas/postApiAuthorsSchema.ts";

function getPostApiAuthorsUrl() {
  const res = { method: 'POST', url: `/api/authors` as const }  
  return res
}

/**
 * @summary Метод создания автора.
 * {@link /api/authors}
 */
export async function postApiAuthors({ data }: { data?: PostApiAuthorsMutationRequest }, config: Partial<RequestConfig<PostApiAuthorsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiAuthorsMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiAuthorsMutationResponse, ResponseErrorConfig<PostApiAuthors400 | PostApiAuthors401 | PostApiAuthors403 | PostApiAuthors500>, PostApiAuthorsMutationRequest>({ method : "POST", url : getPostApiAuthorsUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiAuthorsMutationResponseSchema.parse(res.data)
}